import { RootState } from '../../store';
import { EhrStatus, OrderStatus, Participant, ParticipantStatus, Site, StoreStatus } from '../types/common.types';

export const MOCK_PARTICIPANTS: Participant[] = [
  {
    firstName: 'James',
    surname: 'Walker',
    address1: '12 Station Road',
    address2: 'Flat 2',
    town: 'Leeds',
    postcode: 'LS1 4AB',
    genderIdentity: 'Male',
    sexAtBirth: 'Male',
    dob: '1984-03-12',
    nhsNumber: '9434765919',
    landline: '01132456789',
    mobile: '07700111222',
    email: 'james.walker@example.com',
    communicationOptIn: true,
    enrolmentTs: '2026-01-10T09:12:00Z',
    participantId: 'P-100001',
    participantRef: 'DMUK-0001',
    participantStatus: ParticipantStatus.ACTIVE,
    withdrawalLevel: null,
    withdrawalReason: null,
    withdrawalTs: null,
    consent1: true,
    consent2: true,
    consent3: true,
    consent4: true,
    consent5: true,
    consent6: true,
    consent7: true,
    consent8: true,
    consent9: true,
    consentFormDate: '2026-01-08',
    consentFormVersion: 'v5.0',
    pisDate: '2026-01-08',
    pisVersion: 'v5.0',
    pisConfirm: true,
    videoConfirm: true,
    privacyAccepted: true,
    termsAccepted: true,
    termsVersion: 'v1.0',
    ancestryOptIn: true,
    ehrOptIn: true,
    site: {
      odsCode: 'PF4345',
      siteName: 'Vale of Red Horse',
      siteSystem: 'EMIS',
      siteAddress1: '1 Caxton Road',
      siteAddress2: 'Caxton',
      siteTown: 'Brimlington',
      sitePostcode: 'BD23 8RH',
      isInitiated: true,
    },
    ehr: {
      dataHasArrivedTs: '2026-01-14T11:20:00Z',
      ehrIsLoc: false,
      ehrStatus: EhrStatus.SUCCESS,
      ehrUpdatedTs: '2026-01-20T13:45:00Z',
      ehrIsDeceased: false,
      ehrUpdates: [
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.PENDING,
          ehrUpdatedTs: '2026-01-14T11:20:00Z',
          ehrIsDeceased: false,
        },
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.SUCCESS,
          ehrUpdatedTs: '2026-01-20T13:45:00Z',
          ehrIsDeceased: false,
        },
      ],
    },
    sample: {
      sampleLinkTs: '2026-01-21T09:30:00Z',
      sampleBarcode: 'G100737722',
      sampleReceivedTs: '2026-02-10T09:30:00Z',
      sampleReminderSent: true,
      sampleViable: true,
      orderStatus: OrderStatus.PROCESSED,
      orderNum: 'ORD-90001',
      orderSequencer: 'Illumina',
      orderUpdatedTs: '2026-03-18T15:10:00Z',
      sampleUpdates: [
        {
          orderStatus: OrderStatus.PENDING,
          orderNum: 'ORD-90001',
          orderRef: 'ORD90001',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-01-21T10:00:00Z',
        },
        {
          orderStatus: OrderStatus.CONFIRMED,
          orderNum: 'ORD-90001',
          orderRef: 'ORD90001',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-01-22T10:00:00Z',
        },
        {
          orderStatus: OrderStatus.CREATED,
          orderNum: 'ORD-90001',
          orderRef: 'ORD90001',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-01-24T11:00:00Z',
        },
        {
          orderStatus: OrderStatus.DISPATCHED,
          orderNum: 'ORD-90001',
          orderRef: 'ORD90001',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-01-25T11:30:00Z',
        },
        {
          orderStatus: OrderStatus.RECEIVED,
          orderNum: 'ORD-90001',
          orderRef: 'ORD90001',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-02-10T09:30:00Z',
        },
        {
          orderStatus: OrderStatus.STORED,
          orderNum: 'ORD-90001',
          orderRef: 'ORD90001',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-02-12T10:15:00Z',
        },
        {
          orderStatus: OrderStatus.PROCESSED,
          orderNum: 'ORD-90001',
          orderRef: 'ORD90001',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-18T15:10:00Z',
        },
      ],
    },
    lab: {
      sampleBarcode: 'G100737722',
      boxBarcode: 'BOX-0001',
      samplePosition: '1',
      shipped: true,
      shippedDate: '2026-03-03T08:45:00Z',
    },
  },

  {
    firstName: 'Amelia',
    surname: 'Patel',
    address1: '44 Brook Lane',
    address2: '',
    town: 'Manchester',
    postcode: 'M20 6TR',
    genderIdentity: 'Female',
    sexAtBirth: 'Female',
    dob: '1991-07-28',
    nhsNumber: '4857392016',
    landline: '',
    mobile: '07700999888',
    email: 'amelia.patel@example.com',
    communicationOptIn: false,
    enrolmentTs: '2026-04-03T14:05:00Z',
    participantId: 'P-100002',
    participantRef: 'DMUK-0002',
    participantStatus: ParticipantStatus.ACTIVE,
    withdrawalLevel: null,
    withdrawalReason: null,
    withdrawalTs: null,
    consent1: true,
    consent2: true,
    consent3: true,
    consent4: true,
    consent5: true,
    consent6: true,
    consent7: true,
    consent8: true,
    consent9: true,
    consentFormDate: '2026-04-01',
    consentFormVersion: 'v5.0',
    pisDate: '2026-04-01',
    pisVersion: 'v5.0',
    pisConfirm: true,
    videoConfirm: true,
    privacyAccepted: true,
    termsAccepted: true,
    termsVersion: 'v1.0',
    ancestryOptIn: true,
    ehrOptIn: true,
    site: {
      odsCode: 'B85012',
      siteName: 'North Park Medical Centre',
      siteSystem: 'SystmOne',
      siteAddress1: '9 North Park Road',
      siteAddress2: '',
      siteTown: 'Manchester',
      sitePostcode: 'M20 4BX',
      isInitiated: true,
    },
    ehr: {
      dataHasArrivedTs: null,
      ehrIsLoc: false,
      ehrStatus: EhrStatus.PENDING,
      ehrUpdatedTs: '2026-04-04T09:20:00Z',
      ehrIsDeceased: false,
      ehrUpdates: [
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.PENDING,
          ehrUpdatedTs: '2026-04-04T09:20:00Z',
          ehrIsDeceased: false,
        },
      ],
    },
    sample: {
      sampleLinkTs: '2026-04-05T10:10:00Z',
      sampleBarcode: 'G100737733',
      sampleReceivedTs: null,
      sampleReminderSent: false,
      sampleViable: null,
      orderStatus: OrderStatus.DISPATCHED,
      orderNum: 'ORD-90002',
      orderSequencer: 'Illumina',
      orderUpdatedTs: '2026-04-08T13:15:00Z',
      sampleUpdates: [
        {
          orderStatus: OrderStatus.PENDING,
          orderNum: 'ORD-90002',
          orderRef: 'ORD90002',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-04-05T10:10:00Z',
        },
        {
          orderStatus: OrderStatus.CONFIRMED,
          orderNum: 'ORD-90002',
          orderRef: 'ORD90002',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-04-06T09:30:00Z',
        },
        {
          orderStatus: OrderStatus.CREATED,
          orderNum: 'ORD-90002',
          orderRef: 'ORD90002',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-04-07T11:00:00Z',
        },
        {
          orderStatus: OrderStatus.DISPATCHED,
          orderNum: 'ORD-90002',
          orderRef: 'ORD90002',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-04-08T13:15:00Z',
        },
      ],
    },
    lab: {
      sampleBarcode: 'G100737733',
      boxBarcode: null,
      samplePosition: null,
      shipped: false,
      shippedDate: null,
    },
  },

  {
    firstName: 'Grace',
    surname: 'Hughes',
    address1: '8 Market Street',
    address2: '',
    town: 'Bristol',
    postcode: 'BS1 6AA',
    genderIdentity: 'Female',
    sexAtBirth: 'Female',
    dob: '1976-11-04',
    nhsNumber: '6293847501',
    landline: '01179876543',
    mobile: '07700123456',
    email: 'grace.hughes@example.com',
    communicationOptIn: true,
    enrolmentTs: '2026-02-12T08:40:00Z',
    participantId: 'P-100003',
    participantRef: 'DMUK-0003',
    participantStatus: ParticipantStatus.WITHDRAWN,
    withdrawalLevel: 'FULL',
    withdrawalReason: 'Participant request',
    withdrawalTs: '2026-09-05T16:20:00Z',
    consent1: true,
    consent2: true,
    consent3: true,
    consent4: true,
    consent5: true,
    consent6: true,
    consent7: true,
    consent8: true,
    consent9: true,
    consentFormDate: '2026-02-10',
    consentFormVersion: 'v5.0',
    pisDate: '2026-02-10',
    pisVersion: 'v5.0',
    pisConfirm: true,
    videoConfirm: true,
    privacyAccepted: true,
    termsAccepted: true,
    termsVersion: 'v1.0',
    ancestryOptIn: false,
    ehrOptIn: true,
    site: {
      odsCode: 'L81034',
      siteName: 'Harbourside Health Practice',
      siteSystem: 'EMIS',
      siteAddress1: '21 Harbour Road',
      siteAddress2: '',
      siteTown: 'Bristol',
      sitePostcode: 'BS1 5RT',
      isInitiated: true,
    },
    ehr: {
      dataHasArrivedTs: '2026-02-18T10:00:00Z',
      ehrIsLoc: false,
      ehrStatus: EhrStatus.SUCCESS,
      ehrUpdatedTs: '2026-02-25T12:30:00Z',
      ehrIsDeceased: false,
      ehrUpdates: [
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.PENDING,
          ehrUpdatedTs: '2026-02-12T10:00:00Z',
          ehrIsDeceased: false,
        },
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.SUCCESS,
          ehrUpdatedTs: '2026-02-25T12:30:00Z',
          ehrIsDeceased: false,
        },
      ],
    },
    sample: {
      sampleLinkTs: '2026-02-14T09:05:00Z',
      sampleBarcode: 'G100737744',
      sampleReceivedTs: null,
      sampleReminderSent: true,
      sampleViable: null,
      orderStatus: OrderStatus.CONFIRMED,
      orderNum: 'ORD-90003',
      orderSequencer: 'Illumina',
      orderUpdatedTs: '2026-02-17T11:00:00Z',
      sampleUpdates: [
        {
          orderStatus: OrderStatus.PENDING,
          orderNum: 'ORD-90003',
          orderRef: 'ORD90003',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-02-12T09:05:00Z',
        },
        {
          orderStatus: OrderStatus.HOLD,
          orderNum: 'ORD-90003',
          orderRef: 'ORD90003',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-02-14T10:45:00Z',
        },
        {
          orderStatus: OrderStatus.CONFIRMED,
          orderNum: 'ORD-90003',
          orderRef: 'ORD90003',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-17T11:00:00Z',
        },
      ],
    },
    lab: {
      sampleBarcode: 'G100737744',
      boxBarcode: null,
      samplePosition: null,
      shipped: false,
      shippedDate: null,
    },
  },
  {
    firstName: 'Oliver',
    surname: 'Bennett',
    address1: '27 Greenfield Avenue',
    address2: '',
    town: 'Sheffield',
    postcode: 'S10 2AB',
    genderIdentity: 'Male',
    sexAtBirth: 'Male',
    dob: '1988-05-19',
    nhsNumber: '7048392615',
    landline: '01142345678',
    mobile: '07700144556',
    email: 'oliver.bennett@example.com',
    communicationOptIn: true,
    enrolmentTs: '2026-03-01T09:15:00Z',
    participantId: 'P-100004',
    participantRef: 'DMUK-0004',
    participantStatus: ParticipantStatus.ACTIVE,
    withdrawalLevel: null,
    withdrawalReason: null,
    withdrawalTs: null,
    consent1: true,
    consent2: true,
    consent3: true,
    consent4: true,
    consent5: true,
    consent6: true,
    consent7: true,
    consent8: true,
    consent9: true,
    consentFormDate: '2026-02-28',
    consentFormVersion: 'v5.0',
    pisDate: '2026-02-28',
    pisVersion: 'v5.0',
    pisConfirm: true,
    videoConfirm: true,
    privacyAccepted: true,
    termsAccepted: true,
    termsVersion: 'v1.0',
    ancestryOptIn: true,
    ehrOptIn: true,
    site: {
      odsCode: 'C88021',
      siteName: 'Greenfield Medical Practice',
      siteSystem: 'EMIS',
      siteAddress1: '14 Greenfield Road',
      siteAddress2: '',
      siteTown: 'Sheffield',
      sitePostcode: 'S10 3AA',
      isInitiated: true,
    },
    ehr: {
      dataHasArrivedTs: '2026-03-04T10:00:00Z',
      ehrIsLoc: false,
      ehrStatus: EhrStatus.SUCCESS,
      ehrUpdatedTs: '2026-03-10T12:30:00Z',
      ehrIsDeceased: false,
      ehrUpdates: [
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.PENDING,
          ehrUpdatedTs: '2026-03-02T09:30:00Z',
          ehrIsDeceased: false,
        },
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.SUCCESS,
          ehrUpdatedTs: '2026-03-10T12:30:00Z',
          ehrIsDeceased: false,
        },
      ],
    },
    sample: {
      sampleLinkTs: '2026-03-11T09:00:00Z',
      sampleBarcode: 'G100737755',
      sampleReceivedTs: '2026-03-25T10:30:00Z',
      sampleReminderSent: false,
      sampleViable: false,
      orderStatus: OrderStatus.DESTROYED,
      orderNum: 'ORD-90004',
      orderSequencer: 'Illumina',
      orderUpdatedTs: '2026-04-02T14:20:00Z',
      sampleUpdates: [
        {
          orderStatus: OrderStatus.PENDING,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-11T09:00:00Z',
        },
        {
          orderStatus: OrderStatus.CONFIRMED,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-12T10:15:00Z',
        },
        {
          orderStatus: OrderStatus.CREATED,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-13T11:00:00Z',
        },
        {
          orderStatus: OrderStatus.DISPATCHED,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-14T13:45:00Z',
        },
        {
          orderStatus: OrderStatus.RECEIVED,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-25T10:30:00Z',
        },
        {
          orderStatus: OrderStatus.QCFAIL,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-03-29T09:40:00Z',
        },
        {
          orderStatus: OrderStatus.DESTROYED,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-04-02T14:20:00Z',
        },
      ],
    },
    lab: {
      sampleBarcode: 'G100737755',
      boxBarcode: 'BOX-0004',
      samplePosition: '12',
      shipped: false,
      shippedDate: null,
    },
  },
  {
    firstName: 'Sophie',
    surname: 'Morgan',
    address1: '19 Willow Close',
    address2: '',
    town: 'York',
    postcode: 'YO24 1AB',
    genderIdentity: 'Female',
    sexAtBirth: 'Female',
    dob: '1994-09-16',
    nhsNumber: '5839201746',
    landline: '',
    mobile: '07700155667',
    email: 'sophie.morgan@example.com',
    communicationOptIn: true,
    enrolmentTs: '2026-05-01T09:00:00Z',
    participantId: 'P-100005',
    participantRef: 'DMUK-0005',
    participantStatus: ParticipantStatus.ACTIVE,
    withdrawalLevel: null,
    withdrawalReason: null,
    withdrawalTs: null,
    consent1: true,
    consent2: true,
    consent3: true,
    consent4: true,
    consent5: true,
    consent6: true,
    consent7: true,
    consent8: true,
    consent9: true,
    consentFormDate: '2026-04-30',
    consentFormVersion: 'v5.0',
    pisDate: '2026-04-30',
    pisVersion: 'v5.0',
    pisConfirm: true,
    videoConfirm: true,
    privacyAccepted: true,
    termsAccepted: true,
    termsVersion: 'v1.0',
    ancestryOptIn: true,
    ehrOptIn: true,
    site: {
      odsCode: 'B82045',
      siteName: 'Willow Medical Centre',
      siteSystem: 'EMIS',
      siteAddress1: '4 Willow Road',
      siteAddress2: '',
      siteTown: 'York',
      sitePostcode: 'YO24 2AB',
      isInitiated: true,
    },
    ehr: {
      dataHasArrivedTs: null,
      ehrIsLoc: false,
      ehrStatus: EhrStatus.PENDING,
      ehrUpdatedTs: '2026-05-01T09:30:00Z',
      ehrIsDeceased: false,
      ehrUpdates: [
        {
          ehrIsLoc: false,
          ehrStatus: EhrStatus.PENDING,
          ehrUpdatedTs: '2026-05-01T09:30:00Z',
          ehrIsDeceased: false,
        },
      ],
    },
    sample: {
      sampleLinkTs: '2026-05-01T10:00:00Z',
      sampleBarcode: 'G100737755',
      sampleReceivedTs: null,
      sampleReminderSent: false,
      sampleViable: null,
      orderStatus: OrderStatus.PENDING,
      orderNum: 'ORD-90004',
      orderSequencer: 'Illumina',
      orderUpdatedTs: '2026-05-01T10:00:00Z',
      sampleUpdates: [
        {
          orderStatus: OrderStatus.PENDING,
          orderNum: 'ORD-90004',
          orderRef: 'ORD90004',
          orderSequencer: 'Illumina',
          orderUpdatedTs: '2026-05-01T10:00:00Z',
        },
      ],
    },
    lab: {
      sampleBarcode: 'G100737755',
      boxBarcode: null,
      samplePosition: null,
      shipped: false,
      shippedDate: null,
    },
  },
];

export const MOCK_SITES: Site[] = [
  {
    name: 'North Park Medical Centre',
    code: 'B85012',
    address1: '9 North Park Road',
    address2: '',
    postcode: 'M20 4BX',
    initiated: true,
    provider: 'SystmOne',
  },
  {
    name: 'Harbourside Health Practice',
    code: 'L81034',
    address1: '21 Harbour Road',
    address2: '',
    postcode: 'BS1 5RT',
    initiated: true,
    provider: 'EMIS',
  },
  {
    name: 'Vale of Red Horse Surgery',
    code: 'PF4345',
    address1: '1 Caxton Road',
    address2: 'Caxton',
    postcode: 'BD23 8RH',
    initiated: true,
    provider: 'EMIS',
  },
  {
    name: 'Riverside Family Practice',
    code: 'M83041',
    address1: '18 Riverside Way',
    address2: '',
    postcode: 'B15 2TT',
    initiated: false,
    provider: 'SystmOne',
  },
  {
    name: 'Oakfield Health Centre',
    code: 'G72018',
    address1: '74 Oakfield Avenue',
    address2: 'Westfield',
    postcode: 'GU14 7QH',
    initiated: true,
    provider: 'EMIS',
  },
  {
    name: 'Greenbank Medical Group',
    code: 'P92077',
    address1: '3 Greenbank Road',
    address2: '',
    postcode: 'L18 1HQ',
    initiated: false,
    provider: 'SystmOne',
  },
  {
    name: 'Kingsway Community Surgery',
    code: 'Y00421',
    address1: '42 Kingsway',
    address2: 'Town Centre',
    postcode: 'M19 3AB',
    initiated: true,
    provider: 'EMIS',
  },
  {
    name: 'Hilltop Primary Care Centre',
    code: 'F84022',
    address1: '11 Hilltop Lane',
    address2: '',
    postcode: 'LS16 8DY',
    initiated: true,
    provider: 'SystmOne',
  },
  {
    name: 'Meadow View Practice',
    code: 'D81065',
    address1: '6 Meadow View',
    address2: 'Eastfield',
    postcode: 'YO12 6QA',
    initiated: false,
    provider: null,
  },
  {
    name: 'Station Road Health Centre',
    code: 'A83029',
    address1: '102 Station Road',
    address2: '',
    postcode: 'NE3 1QD',
    initiated: true,
    provider: 'SystmOne',
  },
];

export const MOCK_ROOT_STATE: RootState = {
  participants: {
    errors: null,
    status: StoreStatus.IDLE,
    response: null,
  },
  participant: {
    errors: null,
    status: StoreStatus.IDLE,
    response: null,
  },
  sites: {
    errors: null,
    status: StoreStatus.IDLE,
    response: null,
  },
  site: {
    errors: null,
    status: StoreStatus.IDLE,
    response: null,
  },
};
